import React, { lazy, Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';

// The support team's Telegram Mini App lives under /tg/ in this same bundle,
// but it is a different application: no idp session, no navigation bar, its
// own router. Branching here, before <App/> mounts, keeps useFindUser from
// probing /auth/account_info/ inside Telegram and the private routes from
// sending the WebView to /landing.
//
// Both sides are lazy (Telos loads only the Mini App lazily): the site's
// bundle is heavy, and a phone opening the Mini App in Telegram should not
// download all of it.
const App = lazy(() => import('./App'));
const SupportMiniApp = lazy(
  () => import('./pages/SupportMiniApp/SupportMiniApp'),
);
const isMiniApp = window.location.pathname.startsWith('/tg/');

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Suspense fallback={null}>
      {isMiniApp ? <SupportMiniApp /> : <App />}
    </Suspense>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
